'use client';

import { useIntl } from 'react-intl';

import style from './InfluencersUgcSectionTitle.module.css';

export function InfluencersUgcSectionTitle() {
    const { formatMessage } = useIntl();

    return (
        <div className={style.container}>
            <h2 className={style.title}>
                {formatMessage({
                    id: 'page.home.ugcSection.influenceurSubtitle',
                })}
            </h2>
        </div>
    );
}
